import { Routing } from '@pages/Routings';
import { userAtom } from '@states/Atoms';
import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useRecoilState } from 'recoil';

const dummyName = 'Developer User';

const PublicRouting = () => {
    const [userInfoState, setUserInfoState]: any = useRecoilState(userAtom.infomationState);
    useEffect(() => {
        if (userInfoState?.name !== dummyName) {
            setUserInfoState({name: dummyName});
        }
    }, [userInfoState, setUserInfoState]);
    return (
        <Routes>
            {/* {Routing.base.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)} */}
            {/* {Routing.content.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)} */}
            {Routing.content.map(({ ...configs }, index: number) => <Route key={index} {...configs} />)}
        </Routes>
    );
}

export default PublicRouting;